import React from 'react';
import PropTypes from 'prop-types';

function decodeHtml(html) {
  if (!html) return html;
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

function messageText(term, label, message, className) {
  const labelParts = label.replace(/"/g, '').split('##').filter(elem => elem !== '');
  const indexOfTerm = labelParts.indexOf(term);
  const before = indexOfTerm > 0 ? decodeHtml(labelParts[0]) : null;
  const after = indexOfTerm === 1 ? decodeHtml(labelParts[2]) : decodeHtml(labelParts[1]);

  return (
    <div className={className}>
      {before}<span className={term === 'searchTerm' && 'no-results-text'}>{message}</span>{after}
    </div>
  );
}

const SearchMessage = props => {
  return (props.messages.noResultsFound && props.messages.showingResultsFor ?
    <div className="message-header">
      {messageText('searchTerm', props.labels.noResultsFoundLabel, props.messages.noResultsFound, 'message-title')}
      {messageText('autoCorrectMsg', props.labels.showingResultsForLabel, props.messages.showingResultsFor, 'message-body')}
    </div> : null);
};

SearchMessage.propTypes = {
  messages: PropTypes.shape({
    noResultsFound: PropTypes.string,
    showingResultsFor: PropTypes.string,
  }),
  labels: PropTypes.shape({
    noResultsFoundLabel: PropTypes.string,
    showingResultsForLabel: PropTypes.string,
  }),
};

SearchMessage.defaultProps = {
  messages: {},
  labels: {},
};

export default SearchMessage;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/SearchMessage/SearchMessage.js